import React, { useState } from 'react';

interface Project {
  title: string;
  description: string;
  technologies: string[];
  githubUrl?: string;
  liveUrl?: string;
}

function App() {
  const [isDarkMode, setIsDarkMode] = useState(true);

  const projects: Project[] = [
    {
      title: "Interactive Chinese History Database",
      description: "Interactive tool for exploring ancient Chinese history through visual, connected timelines. A hobby project motivated by the confusing names in certain Chinese eras, with English/Chinese bilingual support. (Private repository)",
      technologies: ["React", "TypeScript","React Flow","Tailwind","TanStack Query"],
      liveUrl: "https://interactive-history-olive.vercel.app/"
    }, 
    {
    title: "Freckers AI Agent",
    description: "AI game-playing agent developed for an open-ended university AI project (scored 29/30). Implemented Minimax algorithm with alpha-beta pruning and iterative deepening. Explored multiple approaches including MCTS before optimising the final solution. Open-ended assignment with no prescribed solution—required independent research and algorithmic innovation.",
    technologies: ["Python", "Minimax Algorithm", "Alpha-Beta Pruning", "Search Optimization"],
    githubUrl: "https://github.com/DustinZoom/Frecker-Game-AI-Agent"
    },
    {
      title: "Minimalist Calorie Tracker",
      description: "Single-file web app I built and used daily for a year to lose 25kg. Tracks macros without the bloat of commercial apps.",
      technologies: ["React", "JSON"],
      githubUrl: "https://github.com/DustinZoom/calorie-tracker-minimalist", 
      liveUrl: "https://dustinzoom.github.io/calorie-tracker-minimalist/"  
      
    }
  ];

  const toggleDarkMode = () => {
    setIsDarkMode(!isDarkMode);
  };

  return (
    <div className={`${isDarkMode ? 'dark bg-gray-900 text-white' : 'bg-white text-black'} min-h-screen transition-colors duration-300`}>
      <button 
        onClick={toggleDarkMode}
        className="fixed top-4 right-4 p-2 bg-gray-200 dark:bg-gray-700 rounded-full"
      >
        {isDarkMode ? '☀️' : '🌙'}
      </button>

      <div className="max-w-4xl mx-auto p-6">
      <header className="text-center mb-16 pt-20">
  <h1 className="text-6xl font-extrabold mb-4 bg-gradient-to-r from-blue-500 to-teal-500 text-transparent bg-clip-text">Lucas Yu</h1>
  <p className="text-lg text-gray-600 dark:text-gray-400 font-light">
    Computer Science Honours Student, Monash University
  </p>
</header>

        <section className="mb-12">
          <h2 className="text-2xl font-semibold mb-6">About Me</h2>
          <p className="dark:text-gray-300">Computer Science Honours student at Monash University, focusing on machine learning and deep learning, with a Bachelor of Science (Computer Science) from the University of Melbourne. Outside of tech, I enjoy lifting and staying active.</p>
        </section>

        <section className="mb-12">
          <h2 className="text-2xl font-semibold mb-6">Projects</h2>
          {projects.map((project, index) => (
            <div 
              key={index} 
              className={`mb-6 p-4 rounded transition-colors duration-300 ${
                isDarkMode 
                  ? 'bg-gray-800 border-gray-700' 
                  : 'bg-white border'
              }`}
            >
              <h3 className="text-xl font-medium">{project.title}</h3>
              <p className={`${isDarkMode ? 'text-gray-300' : 'text-gray-600'}`}>
                {project.description}
              </p>
              <div className="mt-2">
                <strong>Technologies:</strong>
                {project.technologies.map((tech, techIndex) => (
                  <span
                    key={techIndex}
                    className={`ml-2 px-2 py-1 rounded text-sm ${
                      isDarkMode
                        ? 'bg-gray-700 text-gray-200'
                        : 'bg-gray-100 text-gray-800'
                    }`}
                  >
                    {tech}
                  </span>
                ))}
              </div>
              {(project.githubUrl || project.liveUrl) && (
                <div className="mt-4 flex gap-3">
                  {project.githubUrl && (
                    <a
                      href={project.githubUrl}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="px-4 py-2 bg-blue-500 hover:bg-blue-600 text-white rounded transition duration-300 text-sm"
                    >
                      GitHub
                    </a>
                  )}
                  {project.liveUrl && (
                    <a
                      href={project.liveUrl}
                      target="_blank"
                       rel="noopener noreferrer"
                      className="px-4 py-2 bg-blue-500 hover:bg-blue-600 text-white rounded transition duration-300 text-sm"
                    >
                      Live Demo
                    </a>
                  )}
                </div>
              )}
            </div>
          ))}
        </section>

        <section>
          <h2 className="text-2xl font-semibold mb-6">Contact</h2>
          <p>Email: lucasyu185@gmail.com</p>
          <p>
          GitHub:{' '}
          <a
            href="https://github.com/DustinZoom"
            target="_blank"
            rel="noopener noreferrer"
            className="text-blue-500 hover:underline"
          >
            github.com/DustinZoom
          </a>
        </p>
        </section>
      </div>
    </div>
  );
}

export default App;